import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table table-row-dashed" }
const _hoisted_3 = { class: "text-muted fw-bold text-uppercase fs-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, "Lv.", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import { ref } from "vue";
import AccountService from "../../services/AccountService";
import AccountDetail from "../AccountDetail.vue";
import { Memo, Edit } from "@element-plus/icons-vue";
import { UserRoleTypes } from "@/core/types/RoleTypes";
import ChangeGroupForm from "../form/ChangeGroupForm.vue";
import UserService from "@/projects/tenant/modules/users/services/UserService";

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewReferPath',
  props: {
    item: {},
    paymentService: {}
  },
  setup(__props: any) {

const props = __props;


const isLoading = ref(false);
const data = ref(<any>[]);
const isShow = ref(false);
const accountDetailRef = ref<InstanceType<typeof AccountDetail>>();
const changeGroupRef = ref<InstanceType<typeof ChangeGroupForm>>();
const fecthData = async () => {
  isLoading.value = true;
  try {
    const res = await AccountService.queryParentAccounts(props.item.id);
    data.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const onShow = () => {
  isShow.value = true;
  fecthData();
};

const handleGodModeClick = UserService.generateGodModeHandler();

const showChangeGroup = (id: number, group: string) => {
  changeGroupRef.value?.show(id, group);
};
const showAccountDetail = (id: number) => {
  accountDetailRef.value?.show(id, "infos", [] as any);
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_popover, {
      trigger: "click",
      placement: "left",
      width: 900,
      onShow: onShow
    }, {
      default: _withCtx(() => [
        (isShow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("table", _hoisted_2, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.uid")) + " / " + _toDisplayString(_ctx.$t("fields.accountNo")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.email")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.role")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.group")) + "/ " + _toDisplayString(_ctx.$t("fields.code")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
                  ])
                ]),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                      _createVNode(_component_LoadingRing)
                    ]))
                  : (!isLoading.value && data.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                        _createVNode(_component_NoDataBox)
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, "Lv. " + _toDisplayString(index + 1), 1),
                            _createElementVNode("td", {
                              onClick: ($event: any) => (_unref(handleGodModeClick)(item.partyId))
                            }, _toDisplayString(item.name), 9, _hoisted_8),
                            _createElementVNode("td", null, _toDisplayString(item.uid) + " / " + _toDisplayString(item.accountNumber), 1),
                            _createElementVNode("td", null, _toDisplayString(item.user.email), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.accountRole.${item.role}`)), 1),
                            _createElementVNode("td", null, [
                              (item.role === _unref(UserRoleTypes).IB)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createVNode(_component_el_button, {
                                      size: "small",
                                      icon: _unref(Edit),
                                      onClick: ($event: any) => (showChangeGroup(item.id, item.group))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.group), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["icon", "onClick"])
                                  ]))
                                : _createCommentVNode("", true),
                              (item.role === _unref(UserRoleTypes).Sales)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.code), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "success",
                                onClick: ($event: any) => (showAccountDetail(item.id))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(ChangeGroupForm, {
          ref_key: "changeGroupRef",
          ref: changeGroupRef
        }, null, 512)
      ]),
      reference: _withCtx(() => [
        _createVNode(_component_el_button, {
          icon: _unref(Memo),
          size: "small",
          circle: ""
        }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    _createVNode(AccountDetail, {
      ref_key: "accountDetailRef",
      ref: accountDetailRef
    }, null, 512)
  ], 64))
}
}

})